<div class="device-info-container">
  <div class="content">
    <div class="header">
      <div
        class="device-image"
        *ngIf="device.truckSeries?.images as images; else noImage"
      >
        <img
          *ngIf="images[0] as img"
          [lazyLoad]="img.url + '?width=200&height=200&padColor=fff'"
          [defaultImage]="img.url + '?width=50&height=50&padColor=fff'"
          errorImage="./assets/ui/shared/error/not_found_error_image.png"
          src="#"
          [alt]="img.altText"
          [title]="img.titleText"
          width="121px"
          height="auto"
        />
      </div>
      <ng-template #noImage>
        <div class="device-image">
          <img
            lazyLoad="./assets/ui/shared/error/not_found_error_image.png"
            defaultImage="./assets/ui/shared/error/not_found_error_image.png"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            src="#"
            alt="missing_truck"
            title="missing_truck"
            width="121px"
            height="auto"
          />
        </div>
      </ng-template>
      <div class="description">
        <div class="title">{{ device.id }}</div>
        <div
          class="subject"
          *ngIf="
            device.equipmentDescription as equipmentDescription;
            else noCode
          "
        >
          {{ equipmentDescription }}
        </div>
        <ng-template #noCode>
          <div class="subject">{{ 'deviceInfo.label.empty' | translate }}</div>
        </ng-template>
        <a class="link-order-history" href="order-history?truckId={{device.serialNumber}}">
          {{ 'order.history.link' | translate }}
        </a>
      </div>
      <div class="request">
        <div class="label">
          <div class="headline">
            {{ 'deviceInfo.label.status' | translate }}
          </div>
          <kion-status-label
            *ngIf="device.quote as quote; else noQuote"
            [text]="'quote.status.' + quote.status?.toLowerCase() | translate"
            [class]="quote.status"
          ></kion-status-label>
          <ng-template #noQuote>
            <kion-status-label
              [text]="'quote.status.noData' | translate"
            ></kion-status-label>
          </ng-template>
        </div>
        <a
          *ngIf="cartId; else noLink"
          [customRouterLink]="link"
          class="btn-cart"
        >
          <svg
            class="svg-card"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <path
              fill="#222"
              fill-rule="evenodd"
              d="M16.429 13.571H7.658l-.47-1.428h9.24c1.182 0 2.143-.962 2.143-2.143V2.143H3.848L3.372.714H0v1.429h2.342L6.21 13.74c-1.116.39-1.923 1.441-1.923 2.688 0 1.575 1.281 2.857 2.857 2.857 1.576 0 2.857-1.282 2.857-2.857 0-.523-.151-1.007-.397-1.429h4.366c-.246.422-.398.906-.398 1.429 0 1.575 1.282 2.857 2.858 2.857 1.575 0 2.857-1.282 2.857-2.857 0-1.576-1.282-2.858-2.857-2.858zm.714-10V10c0 .394-.32.714-.714.714H6.712L4.324 3.571h12.819zM8.57 16.43c0 .787-.64 1.428-1.428 1.428-.788 0-1.429-.64-1.429-1.428 0-.788.641-1.429 1.429-1.429s1.428.64 1.428 1.429zm7.858 1.428c-.788 0-1.429-.64-1.429-1.428 0-.788.64-1.429 1.429-1.429.787 0 1.428.64 1.428 1.429 0 .787-.64 1.428-1.428 1.428z"
            />
          </svg>
          <div class="badge" *ngIf="badgeNumber">
            <span> {{ badgeNumber }} </span>
          </div>
        </a>
        <ng-template #noLink>
          <div class="btn-cart">
            <svg
              class="svg-card"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="#222"
                fill-rule="evenodd"
                d="M16.429 13.571H7.658l-.47-1.428h9.24c1.182 0 2.143-.962 2.143-2.143V2.143H3.848L3.372.714H0v1.429h2.342L6.21 13.74c-1.116.39-1.923 1.441-1.923 2.688 0 1.575 1.281 2.857 2.857 2.857 1.576 0 2.857-1.282 2.857-2.857 0-.523-.151-1.007-.397-1.429h4.366c-.246.422-.398.906-.398 1.429 0 1.575 1.282 2.857 2.858 2.857 1.575 0 2.857-1.282 2.857-2.857 0-1.576-1.282-2.858-2.857-2.858zm.714-10V10c0 .394-.32.714-.714.714H6.712L4.324 3.571h12.819zM8.57 16.43c0 .787-.64 1.428-1.428 1.428-.788 0-1.429-.64-1.429-1.428 0-.788.641-1.429 1.429-1.429s1.428.64 1.428 1.429zm7.858 1.428c-.788 0-1.429-.64-1.429-1.428 0-.788.64-1.429 1.429-1.429.787 0 1.428.64 1.428 1.429 0 .787-.64 1.428-1.428 1.428z"
              />
            </svg>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="mobile-hider" (click)="toggleClass()">
      <div class="title">
        {{ 'deviceInfo.label.referenceData' | translate }}
      </div>
      <div class="icon">
        <img
          class="icon {{ class }}"
          src="./assets/icons/drop_down_arrow_down_icon.svg"
          title="drop_down_arrow_down_icon"
          alt="drop_down_arrow_down_icon"
        />
      </div>
    </div>
    <div class="body {{ class }}">
      <div class="detail-block">
        <div class="block customerName">
          <div class="label">
            {{ 'deviceInfo.label.customerName' | translate }}
          </div>
          <div
            class="value"
            *ngIf="
              device?.addressOwner?.companyName as companyName;
              else emptyValue
            "
          >
            {{ companyName }}
          </div>
        </div>
        <div class="block customerNumber">
          <div class="label">
            {{ 'deviceInfo.label.customerNumber' | translate }}
          </div>
          <div
            class="value"
            *ngIf="
              device?.addressOwner?.number as companyNumber;
              else emptyValue
            "
          >
            {{ companyNumber }}
          </div>
        </div>
        <div class="block customerTruckDescription">
          <div class="label">
            {{ 'deviceInfo.label.customerTruckDescription' | translate }}
          </div>
          <div class="value" *ngIf="device.description; else emptyValue">
            {{ device.description }}
          </div>
        </div>
        <div class="block erpTruckNumber">
          <div class="label">
            {{ 'deviceInfo.label.erpTruckNumber' | translate }}
          </div>
          <div class="value" *ngIf="device.externalId; else emptyValue">
            {{ device.externalId }}
          </div>
        </div>
        <div class="block locationName">
          <div class="label">
            {{ 'deviceInfo.label.locationName' | translate }}
          </div>
          <div
            class="value"
            *ngIf="device.addressLocation as location; else emptyValue"
          >
            {{ location.companyName }}
          </div>
        </div>
        <div class="block locationNumber">
          <div class="label">
            {{ 'deviceInfo.label.locationNumber' | translate }}
          </div>
          <div
            class="value"
            *ngIf="device.addressLocation as location; else emptyValue"
          >
            {{ location.number }}
          </div>
        </div>
        <div class="block locationCity">
          <div class="label">
            {{ 'deviceInfo.label.locationCity' | translate }}
          </div>
          <div
            class="value"
            *ngIf="device.addressLocation as location; else emptyValue"
          >
            {{ location.town }}
          </div>
        </div>
        <div class="block networkPartner">
          <div class="label">
            {{ 'deviceInfo.label.networkPartner' | translate }}
          </div>
          <div
            class="value"
            *ngIf="device.networkPartner as networkPartner; else emptyValue"
          >
            {{ networkPartner.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyValue>
  <div class="value empty">{{ 'deviceInfo.label.empty' | translate }}</div>
</ng-template>
